import {FormEvent, useState} from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useAuth from '../hooks/useAuth';


const theme = createTheme();

export default function SignIn() {
  const [submitted, setSubmitted] = useState<"start" | "end" | null>(null)
  const {passwordReset} = useAuth();
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setSubmitted("start")
    const data = new FormData(event.currentTarget);
    
    const email= data.get('email') as string;
    if (email){
      passwordReset(email)
      .then(()=>setSubmitted("end"))
      .catch((error)=>{
        console.log({error});
        setSubmitted(null)
      });
    } else {
      setSubmitted(null)
    }
  };

  return (
    <ThemeProvider theme={theme}>
  
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Reset Password
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              
            />
            
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              Send Email
            </Button>
            {submitted ==="end" && <Typography sx={{mt:1, mb:1, textAlign:"center"}} variant="body2" color="primary">Submitted</Typography>}
         
          </Box>
          
        </Box>
      </Container>
      
    </ThemeProvider>
  );
}